<template>
  <div data-elementor-type="wp-post" data-elementor-id="97" class="elementor elementor-97">

    <section class="elementor-section elementor-top-section elementor-element elementor-element-6f14704 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="6f14704" data-element_type="section" data-settings='{"background_background":"classic"}'>
      <div class="elementor-container elementor-column-gap-no">
        <div class="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-32f2539" data-id="32f2539" data-element_type="column">
          <div class="elementor-widget-wrap elementor-element-populated">
            <div class="elementor-element elementor-element-e344774 elementor-widget elementor-widget-footer-about" data-id="e344774" data-element_type="widget" data-widget_type="footer-about.default">
              <div class="elementor-widget-container">
                <div class="footer-widget__column footer-widget__about">
                  <div class="site-footer__top-logo">
                    <router-link to="/"><img loading="lazy" decoding="async" width="100" height="25" src="/wp-content/uploads/2021/11/logo-light.png" alt="RUCSCO"></router-link>
                  </div>
                  <div class="footer-widget__about-text-box">
                    <p class="footer-widget__about-text">
                      {{ description_footer }}
                    </p>
                  </div>
                  <ul class="footer-widget__about-contact list-unstyled ml-0">
                    <li>
                      <div class="icon">
                        <i class="fas fa-envelope"></i>
                      </div>
                      <div class="text">
                        <a :href="'mailto:' + email">{{ email }}</a>
                      </div>
                    </li>
                    <li>
                      <div class="icon">
                        <i class="fas fa-map-marker-alt"></i>
                      </div>
                      <div class="text">
                        <a href="#">{{ address }}</a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-638ea4c" data-id="638ea4c" data-element_type="column">
          <div class="elementor-widget-wrap elementor-element-populated">
            <div class="elementor-element elementor-element-15ba267 elementor-widget elementor-widget-footer-nav-menu" data-id="15ba267" data-element_type="widget" data-widget_type="footer-nav-menu.default">
              <div class="elementor-widget-container">
                <div class="footer-widget__column footer-widget__links clearfix">
                  <h3 class="footer-widget__title">{{ $t('footer_links') }}</h3>

                  <ul id="menu-footer-menu-one" class="footer-widget__links-list list-unstyled clearfix ml-0">
                    <li class="menu-item"><router-link to="/">{{ $t('Home') }}</router-link></li>
                    <li class="menu-item"><router-link to="/about-us">{{ $t('footer_our_mission') }}</router-link></li>
                    <li class="menu-item"><router-link to="/services">{{ $t('Services') }}</router-link></li>
                    <li class="menu-item"><router-link to="/contact-us">{{ $t('Contact') }}</router-link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-e434f7c" data-id="e434f7c" data-element_type="column">
          <div class="elementor-widget-wrap elementor-element-populated">
            <div class="elementor-element elementor-element-6ed7332 elementor-widget elementor-widget-footer-nav-menu" data-id="6ed7332" data-element_type="widget" data-widget_type="footer-nav-menu.default">
              <div class="elementor-widget-container">
                <div class="footer-widget__column footer-widget__links clearfix">
                  <h3 class="footer-widget__title">{{ $t('footer_explore') }}</h3>

                  <ul id="menu-footer-menu-two" class="footer-widget__links-list list-unstyled clearfix ml-0">
                    <li class="menu-item"><a href="/#why-choose">{{ $t('WhyUs') }}</a></li>
                    <li class="menu-item"><router-link to="/about-us">{{ $t('footer_our_story') }}</router-link></li>
                    <li class="menu-item"><router-link to="/blog">{{ $t('footer_latest_news') }}</router-link></li>
                    <li class="menu-item"><router-link to="/contact-us">{{ $t('footer_help_center') }}</router-link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-5ac7ae9" data-id="5ac7ae9" data-element_type="column">
          <div class="elementor-widget-wrap elementor-element-populated">
            <div class="elementor-element elementor-element-d7b978f elementor-widget elementor-widget-footer-subscribe" data-id="d7b978f" data-element_type="widget" data-widget_type="footer-subscribe.default">
              <div class="elementor-widget-container">
                <div class="footer-widget__column footer-widget__newsletter">
                  <div class="site-footer__top-right">
                    <div class="site-footer__top-right-social">
                      <a v-for="(icon, i) in icons" :key="i" target="_blank" :href="icon.link">
                        <i :class="'fab fa-' + icon.title"></i>
                      </a>
                    </div>
                  </div>
                  <div class="site-footer__top-title-box">
                    <h3 class="site-footer__top-title">{{ $t('footer_reach_out') }} <a :href="'mailto:' + email">{{ email }}</a></h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="elementor-section elementor-top-section elementor-element elementor-element-c6c65e3 elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="c6c65e3" data-element_type="section" data-settings='{"background_background":"classic"}'>
      <div class="elementor-container elementor-column-gap-no">
        <div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-b960b84" data-id="b960b84" data-element_type="column">
          <div class="elementor-widget-wrap elementor-element-populated">
            <div class="elementor-element elementor-element-5c07a38 elementor-widget elementor-widget-footer-copyright" data-id="5c07a38" data-element_type="widget" data-widget_type="footer-copyright.default">
              <div class="elementor-widget-container">
                <footer class="site-footer">
                  <div class="site-footer__bottom">
                    <div class="container">
                      <div class="row">
                        <div class="col-xl-12">
                          <div class="site-footer__bottom-inner">
                            <div class="site-footer__bottom-left">
                              <p class="site-footer__bottom-text">&copy; {{ $t('footer_copyrights') }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </footer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

  <section>
    <div
        class="icon-whatsapp-footer"
        v-if="whatsapp"
    >
      <a :href="`https://wa.me/${whatsapp}`" class="iconwhatsapp" target="_blank">
        <i class="fab fa-whatsapp" style="font-size:30px"></i>
      </a>
    </div>
  </section>
</template>

<script>
import { useSiteData } from '@/composables/useSiteData';

export default {
  setup() {
    const { icons, address, description_footer, phone, email, whatsapp, loadSiteData } = useSiteData();
    return { icons, address, description_footer, phone, email, whatsapp, loadSiteData };
  },
  mounted() {
    this.loadSiteData();
  },
};
</script>

<style>
.site-footer__top-right-social {
  display: inline-flex;
}
.site-footer__top-logo img {
  width: 250px;
  margin-bottom: 10px;
}
.site-footer__top-title-box {
  margin: 0 !important;
  text-align: center !important;
}
.icon-whatsapp-footer {
  position: fixed;
  right: 8%;
  bottom: 20px;
  z-index: 555;
  cursor: pointer;
}
.iconwhatsapp {
  background: #01af00;
  color: #fff !important;
  border-radius: 50%;
  width: 55px;
  height: 55px;
  display: grid;
  text-align: center;
  place-items: center;
  text-decoration: none;
  margin-bottom: 5px;
}
p.footer-widget__about-text {
  color: #08814a;
}
@media (max-width: 767px) {
  span.scroll-to-target.scroll-to-top {
    bottom: 20px !important;
  }
  .icon-whatsapp-footer {
    bottom: 65px !important;
    right: 9% !important;
  }
}
</style>
